
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Mankhurdtopunecabs() {



    const cardData =
    {
        keyword: 'Mankhurd to Pune Cab ',
        heading: 'Mauli Cabs: Mankhurd to Pune Cab ',
        headingDescription: 'Mauli Cabs provides reliable and comfortable Mankhurd to Pune cab services, ensuring a smooth and hassle-free travel experience from Mumbai’s eastern suburb to your destination in Pune. Whether you are planning a business trip, family visit, or weekend getaway, our fleet of well-maintained sedans, SUVs, and premium cabs is ready to suit your travel needs. With experienced drivers, on-time pickups, transparent pricing, and no hidden charges, Mauli Cabs guarantees a safe, timely, and comfortable journey from Mankhurd to Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located about 30 km from Pune, Sinhagad Fort is a favorite spot for trekking and offers panoramic views and a rich historical background."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganesh temples in Maharashtra, this temple is revered for its magnificent idol and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Parvati Hill",
        "description": "Parvati Hill offers a serene temple complex atop a hill with beautiful views of the city and is one of the oldest heritage sites in Pune."
    },
    {
        "title": "Osho Garden and Ashram",
        "description": "Located in Koregaon Park, this peaceful garden and spiritual center draws global visitors for meditation and relaxation in tranquil surroundings."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum showcases a fascinating collection of artifacts, including musical instruments, weaponry, and antiques, celebrating India’s cultural heritage."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Inspired by a Japanese design, this beautifully landscaped garden is perfect for calm walks and nature photography."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Also known as Katraj Zoo, this park houses various species of animals and a dedicated snake park, popular with families and kids."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, this ancient monument offers spiritual solace in the middle of the city."
    }
],

"services": [
    {
      "name": "Mankhurd to Pune Cab Service",
      "description": "Book a comfortable cab from Mankhurd to Pune for a stress-free ride. Our service ensures on-time pickup, courteous drivers, and a range of vehicle options including sedans, SUVs, and MPVs."
    },
    {
      "name": "Mankhurd to Pimpri Cab",
      "description": "Travel from Mankhurd to Pimpri in Pune with our affordable and reliable cab service. Ideal for daily commutes or business visits, enjoy a smooth and safe journey with transparent fares."
    },
    {
      "name": "Mankhurd to Pune One Way Cab",
      "description": "Need a one-way drop from Mankhurd to Pune? Our one-way cabs are budget-friendly and convenient, with no return fare. Great for single travelers, students, or quick city transfers."
    },
    {
      "name": "Chembur to Pune Car Fare",
      "description": "Get affordable car fares from Chembur to Pune with our flexible booking options. Choose from economy to luxury cars based on your travel preference and budget."
    },
    {
      "name": "Belapur to Pune by Taxi",
      "description": "Enjoy a smooth journey from Belapur to Pune with our professional taxi service. Whether for business or leisure, our cabs ensure comfort, reliability, and timely arrivals."
    },
    {
      "name": "Belapur to Pune One Way Cab",
      "description": "Book a one-way cab from Belapur to Pune for convenient and cost-effective travel. No need to pay for a return trip, and you can select from a variety of well-maintained vehicles."
    },
    {
      "name": "Belapur to Pimpri Chinchwad Cab",
      "description": "Travel comfortably from Belapur to Pimpri Chinchwad with our safe and efficient cab service. Ideal for intercity commutes, office transfers, or personal trips."
    },
    {
      "name": "Belapur to Baner Cab Fare",
      "description": "Check affordable and transparent cab fares from Belapur to Baner, Pune. Perfect for travelers heading to IT hubs or residential areas with flexible ride options."
    },
    {
      "name": "Seawoods to Pune Cab Fare",
      "description": "Get competitive pricing for a cab ride from Seawoods to Pune. We offer a range of cars and experienced drivers to ensure a seamless, comfortable journey."
    },
    {
      "name": "Seawoods to Pune Station Cab",
      "description": "Book a direct cab from Seawoods to Pune Railway Station. Whether you're catching a train or picking someone up, our punctual and safe service has you covered."
    },
    {
      "name": "Sanpada to Pune Cab Service",
      "description": "Travel from Sanpada to Pune easily with our dependable cab service. Ideal for daily commuters, weekend travelers, or airport transfers with flexible scheduling."
    },
    {
      "name": "Ghansoli to Pune Cab",
      "description": "Book a cab from Ghansoli to Pune for a smooth and hassle-free experience. Our drivers are trained, our cars are clean, and pricing is fully transparent."
    },
    {
      "name": "Mumbai to Pune Taxi Booking",
      "description": "Easily book your taxi from anywhere in Mumbai to Pune with our fast and reliable service. Enjoy comfortable rides, multiple vehicle choices, and round-the-clock support for all your travel needs."
    }
  ],
  "tableData": [
    ["Mankhurd to Pune Cab Service", "Mankhurd to Pimpri Cab"],
    ["Mankhurd to Pune One Way Cab", "Chembur to Pune Car Fare"],
    ["Belapur to Pune by Taxi", "Belapur to Pune One Way Cab"],
    ["Belapur to Pimpri Chinchwad Cab", "Belapur to Baner Cab Fare"],
    ["Seawoods to Pune Cab Fare", "Seawoods to Pune Station Cab"],
    ["Sanpada to Pune Cab Service", "Ghansoli to Pune Cab"],
    ["Mumbai to Pune Taxi Booking", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Cab Service from Mankhurd to Pune",
        "WhyChoosedescription": "Mauli Cabs provides a trusted and punctual cab service from Mankhurd to Pune, ensuring a comfortable, timely, and hassle-free journey."
    },
    {
        "WhyChooseheading": "Clean and Comfortable Vehicles",
        "WhyChoosedescription": "Travel in our air-conditioned, well-maintained sedans, SUVs, and premium cars. All vehicles are spacious, sanitized, and equipped for long-distance comfort."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our drivers are well-versed with the Mankhurd to Pune route and help you avoid traffic and delays, ensuring a smooth and efficient trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy competitive rates with no hidden charges. Mauli Cabs ensures transparent pricing and excellent value for your Mankhurd to Pune journey."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability",
        "WhyChoosedescription": "We operate round-the-clock to match your schedule. Whether it’s an early morning pickup or a late-night ride, we’re always ready to serve you."
    },
    {
        "WhyChooseheading": "Instant Booking and Live Tracking",
        "WhyChoosedescription": "Book instantly via our website or app, and track your cab in real time with live updates on driver location and estimated arrival."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Ride",
        "WhyChoosedescription": "Your safety is our priority. Our cabs are regularly sanitized, and drivers follow strict hygiene and safety protocols for a secure travel experience."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Choose from multiple payment methods including UPI, cards, wallets, or cash for a smooth and convenient booking experience."
    }
]












    }

    const faqData = [
        {
            question: 'How do I book a cab from Mankhurd to Pune with Mauli Cabs?',
            answer: 'Booking a cab from Mankhurd to Pune is quick and easy with Mauli Cabs. Just visit our website or mobile app, enter "Mankhurd" as your pickup location and "Pune" as your destination. Choose your preferred vehicle type, confirm the booking, and you are all set. Our support team is available 24/7 for any help.',
        },
        {
            question: 'What cab options are available for the Mankhurd to Pune route?',
            answer: 'Mauli Cabs offers multiple vehicle types for the Mankhurd to Pune journey, including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, and luxury vehicles. Select a cab based on your comfort and luggage requirements.',
        },
        {
            question: 'Is the fare fixed for the Mankhurd to Pune cab?',
            answer: 'Yes, the fare for Mankhurd to Pune is fixed and includes tolls, fuel, driver charges, and taxes. You’ll see the complete fare at the time of booking with no hidden charges.',
        },
        {
            question: 'How long does it take to travel from Mankhurd to Pune?',
            answer: 'The journey from Mankhurd to Pune usually takes around 3.5 to 5 hours, depending on traffic and road conditions. For a smoother ride, try to travel outside peak hours.',
        },
        {
            question: 'Can I book a one-way or round-trip cab from Mankhurd to Pune?',
            answer: 'Yes, Mauli Cabs allows both one-way and round-trip bookings from Mankhurd to Pune. Round-trip bookings are ideal if you plan to return the same or next day.',
        },
        {
            question: 'Is the Mankhurd to Pune cab service available at all hours?',
            answer: 'Yes, our service operates 24/7, so you can book your cab from Mankhurd to Pune anytime, whether it’s for early morning travel or a late-night ride.',
        },
        {
            question: 'Can I carry additional luggage on this route?',
            answer: 'Yes, you can carry extra luggage. If you have large or bulky items, we recommend booking a bigger vehicle such as an SUV or Innova Crysta for comfort.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Armaan Shaikh",
            position: "Chartered Accountant",
            text: "I used Mauli Cabs for my trip from Mankhurd to Pune and was really impressed. Clean car, punctual service, and very polite driver. The fixed fare gave me peace of mind. Great service!",
            image: "/img/testimonial/testimonial-thumb-1-85.png",
        },
        {
            name: "Ms. Shraddha Kale",
            position: "Media Professional",
            text: "Booked a cab from Mankhurd to Pune for a client meeting. The car arrived on time, and the driver knew the best route. Safe, smooth, and professional experience. Will book again!",
            image: "/img/testimonial/testimonial-thumb-1-86.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mankhurd to Pune Cab Service",
        "description": "Book a comfortable and affordable taxi service from Mankhurd to Pune. Choose from various options like Innova, Ertiga, and sedan for a smooth ride.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "850"
        }
      };
      
    
      


    return (
        <div>
            <GTag/>


<Helmet>
        <title>Mankhurd to Pune Cab Service | Book Your Taxi | Mauli Cabs</title>
        <meta
          name="description"
          content="Need a reliable taxi service from Mankhurd to Pune? Book with Mauli Cabs and choose from a range of vehicles including Innova, Ertiga, and sedan for a comfortable journey."
        />
        <meta
          name="keywords"
          content="Mankhurd to Pune cab service, Mankhurd to Pimpri cab, Mankhurd to Pune one way cab, Chembur to Pune car fare, Belapur to Pune by taxi, Belapur to Pune one way cab, Belapur to Pimpri Chinchwad cab, Belapur to Baner cab fare, Seawoods to Pune cab fare, Seawoods to Pune station cab, Sanpada to Pune cab service, Ghansoli to Pune cab, Mumbai to Pune taxi booking"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/125.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mankhurdtopunecabs;